import script from "./SubRouting.vue?vue&type=script&setup=true&lang=js"
export * from "./SubRouting.vue?vue&type=script&setup=true&lang=js"

import "./SubRouting.vue?vue&type=style&index=0&id=f70eeeb4&lang=scss"

const __exports__ = script;

export default __exports__